import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GoApplicationPurposeSelectionComponent } from '../shared/components/go-application-purpose-selection/go-application-purpose-selection.component';
import { ApplicationState } from '../../../../core/models/application-state/application-state';
import { AuthenticatedUser } from '../../../../core/models/authenticated-user';
import { ApplicationPageFacadeService } from '../../direct-entry/shared/services/application-page-facade/application-page-facade.service';
import { UserStateService } from '../../../user/shared/services/user-state/user-state.service';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { RouteConstants } from '../../../../core/constants/routes';
import { ExternalLinks } from '../../../../core/constants/external-links';

@Component({
    selector: 'app-go-complete',
    imports: [
        GoApplicationPurposeSelectionComponent,
        MatButtonModule,
        RouterModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-complete.component.html',
})
export class GoCompleteComponent implements OnInit {
    applicationState: ApplicationState | null = null;
    user: AuthenticatedUser | null = null;
    externalLinks = ExternalLinks.enterpriseWireless;

    constructor(
        private readonly router: Router,
        private readonly applicationPageFacadeService: ApplicationPageFacadeService,
        private readonly userStateService: UserStateService,
    ) {}

    ngOnInit(): void {
        this.applicationState =
            this.applicationPageFacadeService.applicationStateService.getCurrentApplicationState();

        this.user = this.userStateService.getUser();
    }

    backToPurposeOfFiling(): void {
        this.router.navigate([
            RouteConstants.Go.getFullRoute('purposeOfFiling'),
        ]);
    }

    get userOrganizationName(): string {
        if (this.user === null) {
            return '';
        }

        return this.user.organizationName || '';
    }
}
